import { createAction } from '@reduxjs/toolkit';

export const toggleMenu = createAction('APP_MENU_TOGGLE');
